import React from "react";
import classnames from "classnames";
import { node, string } from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

import styles from "./styles.js";

const useStyles = makeStyles(styles);

export const FullPageLayout = ({ children, backgroundImage, photoCredit }) => {
  const classes = useStyles();
  const bgStyle = backgroundImage
    ? { backgroundImage: `url("${backgroundImage}")` }
    : undefined;
  const fullPageClass = classnames(classes.fullPage, {
    [classes.dark]: backgroundImage !== undefined,
  });

  return (
    <div className={classes.wrapper}>
      <div className={fullPageClass} style={bgStyle}>
        {children}
      </div>

      <div className={classes.photoCredit}>{photoCredit}</div>
    </div>
  );
};

FullPageLayout.propTypes = {
  children: node.isRequired,
  backgroundImage: string,
  photoCredit: node,
};

export default FullPageLayout;
